<template>
	<div class="ReInputSearchDrop">
		<base-input
			:disabled="disabled"
			:name="name"
			:placeholder="placeholder"
			addon-left-icon="tim-icons icon-zoom-split"
			v-model="value.inputText"
			@keyup="getSearch"
			@blur="checkInputText"
			autocomplete="off"
		>
		</base-input>
		<ul v-if="bInSearch" class="my-0 mb-1 dropdown-menu show">
			<li class="searchProg dropdown-item cursor-pointer">Поиск данных <i class="tim-icons icon-refresh-02 rotate"></i></li>
		</ul>
		<ul v-if="!bInSearch" :class="[{'show':masDataOpt.length > 0},]" v-click-outside="hide" class="my-0 mb-1 dropdown-menu">
			<li v-for="opt in masDataOpt" :key="opt.value"
				@click="ClickOnOpt(opt)"
				style="white-space: normal;"
				class="dropdown-item cursor-pointer" v-html="PrintOptText(opt)"></li>
		</ul>
	</div>
</template>

<script>
import debounce from 'src/mixins/debounce';

	// import debounce from 'src/util/debounce.js';
	export default {
		name: 'ReInputSearchDrop',
		mixins: [debounce],
		components: {

		},
		props: {
			placeholder: String,
			name: String,
			objApiMethod: {
				type: Object,
				default() {	return {}; }
			},
			strApiMethod:{
				type: String,
				default:'GET',
			},
			strApiMethodKey:{
				type: String,
				required: true
			},
			MinTxtLen: {
				type: Number,
				default:2,
			},
			value: {
				type: Object,
				default() {	return {
					inputText: '',
					selectedVal:''
				}; }
			},
			strType:{
				type: String,
				default: 'staff',
			},
			disabled:{
				type: Boolean,
				default: false,
			},
			disableCache:{
				type: Boolean,
				default: false,
			},
			required:{
				type: Boolean,
				default: false,
			},			
		},
		data () {
			return {
				ver: 1,
				inputText: '',
				bInSearch: false,
				iApiCallCnt: 0,
				masDataOpt: [],
				cacheOpt:{},
				timer: null,
			}
		},
		methods: {
			getSearch(ev){
				this.debounce((ev)=>{
					this.startSearch(ev);
				},500);
			},
			// getSearch: debounce(this, ((ev)=>{
			// 	console.log(this,ev);
			// 	this.startSearch(ev);
			// }).bind(this),500),
			/*
			getSearch(ev){
				
				if(this.timer)
					clearTimeout(this.timer);
				this.timer=setTimeout(()=>{
					console.log('timer',new Date());
					this.startSearch(ev);
				}, 60000);
				console.log('search', this.timer, new Date());
			},
			*/
			startSearch(ev){
				if ((this.value.inputText.length > this.MinTxtLen) && !this.$GVO.isEmpty(this.objApiMethod)){
					const masFilterKeys = Object.keys(this.objApiMethod.flt);
					if(masFilterKeys.length>0){
						this.objApiMethod.flt[this.strApiMethodKey] = this.value.inputText;
						// if(this.name=="contacts" && this.strType == 'staff'){
						// 	this.objApiMethod.flt[this.strApiMethodKey] = this.value.inputText.replace(/ /g, ''); //не удобно искать, если всавляем телефон с пробелами, удаляем пробелы
						// }
						this.bInSearch = true;
						this.iApiCallCnt++;
						let iCurApiCallCnt = this.iApiCallCnt;
						let strMethod = this.strApiMethod;
						if(this.strType == 'gk'){strMethod = 'GET_CAT_METRO_DIST_GK_DEV';}
						this.$GVO.ApiCall(strMethod,this.objApiMethod)
							.then((objApi) => { 
								if(objApi.success === true){ //console.log(objApi);
									if ((objApi.total > 0 || objApi.data.length > 0) && this.value.inputText.length > this.MinTxtLen){
										if (iCurApiCallCnt == this.iApiCallCnt){
											this.masDataOpt = [];
											this.bInSearch = false;
											//console.log(this.strType);
											if(this.strType == 'staff'){
												for (let i = 0; i < objApi.data.length; i++) {
													this.masDataOpt.push({text:objApi.data[i].fio,value:objApi.data[i].code});
												}
											}else if(this.strType == 'address.addr'){
												//console.log(objApi.data);
												for (let i = 0; i < objApi.data.length; i++) {
													this.masDataOpt.push({text:objApi.data[i].text_addr,value:objApi.data[i].ad8_id, ...objApi.data[i]});
												}
											} else if(this.strType == 'client'){
												for (let i = 0; i < objApi.data.length; i++) {
													this.masDataOpt.push({text:objApi.data[i].fio,value:objApi.data[i].id});
												}
											} else if(this.strType == 'otdel'){
												for (let i = 0; i < objApi.data.length; i++) {
													this.masDataOpt.push({text:objApi.data[i].name,value:objApi.data[i].id});
												}
											} else if(this.strType == 'gk'){
												for (let i = 0; i < objApi.data.length; i++) {
													//console.log(objApi.data[i]);
													this.masDataOpt.push({text:objApi.data[i].name,value:objApi.data[i].id});
													//this.masDataOpt.push({text:objApi.data[i].gk_name,value:objApi.data[i].PK});
												}
											}
											this.iApiCallCnt = 0;
											//console.log('getSearch',this.masDataOpt);
										}
									}else{
										if (iCurApiCallCnt == this.iApiCallCnt) {
											this.bInSearch = false;
											this.masDataOpt = [];
										}
									}
								}else{
									if (iCurApiCallCnt == this.iApiCallCnt) {
										this.bInSearch = false;
										this.masDataOpt = [];
									}
								}
							}).catch(errorObjApi => console.error(errorObjApi));
					}
				}else{
					this.masDataOpt = [];
					this.bInSearch = false;
					this.iApiCallCnt = 0;
					//eventEmitter.$emit('ObSearchDrop_cleared',true);
				}
			},
			ClickOnOpt(opt){
				//console.log(opt);
				const strOldTypedText = this.$GVO.unlinkObject(this.value.inputText);
				this.cacheOpt = this.$GVO.unlinkObject(opt);
				this.value.inputText = opt.text;
				this.value.selectedVal = opt.value;
				this.$emit('typedText', strOldTypedText);
				if(this.strType == 'address.addr'){
					this.$emit('input', {inputText:opt.text,selectedVal:opt.value,...opt});
					this.$emit('change',{inputText:opt.text,selectedVal:opt.value,...opt});
				}else{
					this.$emit('input', {inputText:opt.text,selectedVal:opt.value});
					this.$emit('change',{inputText:opt.text,selectedVal:opt.value});
				}
				this.masDataOpt = [];
			},
			PrintOptText(opt){
				if (typeof opt.value != 'undefined'){
					if (typeof opt.text != 'undefined'){
						return '<span>'+opt.text+'</span>';
					}
				}
			},
			hide(){
				this.masDataOpt = [];
			},
			checkInputText(evt){
				if(this.disableCache===false){
					if(this.value.selectedVal==this.cacheOpt.value && this.value.inputText!=this.cacheOpt.text){
						this.value.inputText = this.$GVO.unlinkObject(this.cacheOpt.text);
						this.value.selectedVal = this.$GVO.unlinkObject(this.cacheOpt.value);
						//this.ClickOnOpt(this.$GVO.unlinkObject(this.cacheOpt));
					}
				}
			}
		},
		mounted(){
			this.cacheOpt = this.$GVO.unlinkObject(this.value);
		}
	}
</script>
<style scoped>
.ReInputSearchDrop {
	position: relative;
}
.ReInputSearchDrop ul{
	width: max-content;
}
    
</style>
